import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const state = {
  direction: null,
  locale: { countryCode: 'DE', language: 'de' },
  market: null,
  labels: null,
  links: null,
  bookingActive: false,
  rescheduleActive: false,
  aemFormsResources: null,
  cancellationFormConfig: null,
  dealerRadius: null,
  dealerRadiusArray: [],
  initialUnavailableDays: 0,
  formConfig: null,
  context: '',
  modelMapping: undefined,
  modelSeriesMapper: undefined,
  searchProfileName: '',
  models: [],
  sharedNotifications: {
    minimumDriverAgeNotifications: {
      active: false,
    },
    driverLicenseNotifications: {
      active: false,
      weight: 0,
    },
  },
  isStandalone: false,
  pickMeUpFromHome: { active: false },
  isCo2EmissionAndFuelConsumptionVisibile: false,
  isEnergyEfficiencyVisibile: false,
  trackingSplitters: {
    trackingParameterSplitter: '',
    trackingParameterKeyValueSplitter: '',
  },
  utmParameters: '',
};

export default {
  state,
  getters,
  mutations,
  actions,
};
